<template>
    <div class="table_tem">
        <!-- 表格模板 -->
        <el-table
                :data="tableData"
                style="width: 100%"
                :border="border"
                max-height="550"
                @select="select"
                @select-all="selectAll"
        >
            <el-table-column fixed v-if="isSelection" type="selection" align="center" width="50"></el-table-column>
            <el-table-column
                    fixed
                    v-if="isIndex"
                    type="index"
                    :label="indexLabel"
                    align="center"
                    width="80"
            ></el-table-column>
            <!-- 数据 -->
            <el-table-column
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    align="center"
                    v-for="(item,index) of tableCols"
                    :key="index"
                    :fixed="item.isFixed"
            >
                <template slot-scope="scope">
                    <!-- 操作按钮 -->
                    <span v-if="item.type==='Button'">
            <el-button
                    v-for="(btn,index) of item.btnList"
                    :key="index"
                    :disabled="btn.isDisabled && btn.isDisabled(scope.row)"
                    :type="btn.type"
                    :size="btn.size || size"
                    :icon="btn.icon"
                    @click="dataOperating(btn.handle(),scope.row)"
            >{{btn.label}}</el-button>
          </span>
                    <!-- 开关按钮 -->
                    <el-switch
                            v-if="item.type==='Switch'"
                            active-text="off"
                            inactive-text="on"
                            active-value="1"
                            inactive-value="0"
                            v-model="scope.row.status"
                            @change="querySwitchVal(scope.row)"
                    ></el-switch>

                    <!-- 图片 -->
                    <img v-if="item.type==='image'" :src="scope.row.logoPath"/>
                    <!-- 默认 -->

                    <span
                            v-if="item.type==='industry'"
                            class="text_one_line"
                            :title="scope.row.industryENName"
                    >{{scope.row.industryENName}}</span>
                    <span
                            v-if="item.type==='website'"
                            class="text_one_line"
                            :title="scope.row.website"
                    >{{scope.row.website}}</span>
                    <span
                            v-if="item.type==='Location'"
                            class="text_one_line"
                            :title="scope.row.address"
                    >{{scope.row.address}}</span>
                    <span
                            v-if="item.type==='Name'"
                            class="text_one_line"
                            :title="scope.row.ENName"
                    >{{scope.row.ENName}}</span>
                    <span
                            v-if="item.type==='role'"
                            class="text_one_line"
                            :title="scope.row.roleName"
                    >{{scope.row.roleName}}</span>
                    <span
                            v-if="item.type==='description'"
                            class="text_one_line"
                            :title="scope.row.roleDesc"
                    >{{scope.row.roleDesc}}</span>
                    <span
                            v-if="item.type==='createtime'"
                            class="text_one_line"
                            :title="scope.row.createTime"
                    >{{scope.row.createTime}}</span>
                    <el-switch
                            v-if="item.type==='Switch1'"
                            active-text="off"
                            inactive-text="on"
                            active-value="1"
                            inactive-value="0"
                            v-model="scope.row.status"
                            @change="querySwitchVal1(scope.row)"
                    ></el-switch>

                    <!-- 用户 -->
                    <span
                            v-if="item.type==='Account'"
                            class="text_one_line"
                            :title="scope.row.account"
                    >{{scope.row.account}}</span>
                    <span
                            v-if="item.type==='Role'"
                            class="text_one_line"
                            :title="scope.row.email"
                    >{{scope.row.email}}</span>
                    <span
                            v-if="item.type==='Name'"
                            class="text_one_line"
                            :title="scope.row.userName"
                    >{{scope.row.userName}}</span>
                    <span
                            v-if="item.type==='createTime'"
                            class="text_one_line"
                            :title="scope.row.createTime"
                    >{{scope.row.createTime}}</span>
                    <el-switch
                            v-if="item.type==='Switch2'"
                            active-text="off"
                            inactive-text="on"
                            active-value="1"
                            inactive-value="0"
                            v-model="scope.row.status"
                            @change="querySwitchVal2(scope.row)"
                    ></el-switch>

                    <!-- 组 -->
                    <span
                            v-if="item.type==='english'"
                            class="text_one_line"
                            :title="scope.row.ENName"
                    >{{scope.row.ENName}}</span>
                    <span
                            v-if="item.type==='chinese'"
                            class="text_one_line"
                            :title="scope.row.ZHName"
                    >{{scope.row.ZHName}}</span>
                    <span
                            v-if="item.type==='updateTime'"
                            class="text_one_line"
                            :title="scope.row.updateTime"
                    >{{scope.row.updateTime}}</span>
                    <el-switch
                            v-if="item.type==='Switch3'"
                            active-text="off"
                            inactive-text="on"
                            active-value="1"
                            inactive-value="0"
                            v-model="scope.row.status"
                            @change="querySwitchVal3(scope.row)"
                    ></el-switch>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination" v-if="isPagination">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    background
                    layout="prev, pager, next"
                    :page-size="pagination.pageSize"
                    :current-page="pagination.pageNum"
                    :total="pagination.total"
                    class="page"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // 表格型号：mini,medium,small
            size: {type: String, default: "medium"},
            // 是否显示表格索引
            isIndex: {type: Boolean, default: false},
            indexLabel: {type: String, default: "Number"},
            // 是否显示表格复选框
            isSelection: {type: Boolean, default: false},
            // 是否显示分页
            isPagination: {type: Boolean, default: true},
            // 分页数据
            pagination: {
                type: Object,
                default: () => ({pageSize: 5, pageNum: 1, total: 0})
            },
            // 表格数据
            tableData: {type: Array, default: () => []},
            // 表格列配置
            tableCols: {type: Array, default: () => []},
            // 当前列是否固定
            isFixed: {type: Boolean || String, default: false}
        },
        name: "TableTem",
        data() {
            return {
                border: true,
                value: "100"
            };
        },
        methods: {
            // 表格勾选
            select(rows, row) {
                this.$emit("select", rows, row);
            },
            // 全选
            selectAll(rows) {
                this.$emit("selectAll", rows);
            },
            // 第几页
            handleCurrentChange(val) {
                this.pagination.pageNum = val;
                this.$emit("handleCurrentChange", val);
            },
            // 每页显示条数
            handleSizeChange(val) {
                this.pagination.pageSize = val;
                this.$emit("handleSizeChange", val);
            },
            // 开关状态
            querySwitchVal(row) {
                this.$emit("switchVal", row);
            },
            querySwitchVal1(row) {
                this.$emit("switchVal1", row);
            },
            querySwitchVal2(row) {
                this.$emit("switchVal2", row);
            },
            querySwitchVal3(row) {
                this.$emit("switchVal3", row);
            },
            dataOperating(button, row) {
                let result = {
                    button: button,
                    rowData: row
                };
                this.$emit("passRowData", result);
            }
        },
        watch: {
            tableData() {
                this.tableData.map(item => {
                    item.status = item.status.toString();
                    return item;
                });
            }
        }
    };
</script>

<style scoped>
    img {
        /*max-width: 50%;*/
        height: 45px;
    }

    .pagination {
        text-align: center;
        margin: 20px;
        display: flow-root;
    }

    /* 文字一行显示 多出隐藏 */
    .text_one_line {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }

    .text_two_line {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .table_tem {
        padding: 10px 0;
        margin-top: 10px;
    }

    .table_tem >>> .el-table .el-table__header th {
        background: #f7f8fa;
        font-size: 14px;
        color: #6c757d;
    }
    .table_tem >>> .el-table__header-wrapper {
        height: auto !important;
    }
</style>